<template>
    <div>
        <legend>ユーザ一覧</legend>
        <div class="container">

            <div>
                <simple-search v-model="keyword" @find="find()" @clear="clear()" placeholder="ユーザー名、ADアカウント、メールアドレス"></simple-search>
            </div>

            <div class="text-end mb-2">
                <button class="btn btn-outline-primary me-2 d-inline-flex align-items-center" @click="append()">
                    <TablerIcon name="IconPlus" :size="18" class="me-1" />
                    新規追加...
                </button>
                <button class="btn btn-outline-primary d-inline-flex align-items-center" @click="sync()">
                    <TablerIcon name="IconUserSearch" :size="18" class="me-1" />
                    ADスキャン...
                </button>
            </div>

            <div class="sticky">
                <pagination v-bind="users" @goto="goto"></pagination>
            </div>

            <div class="card my-3" v-for="v in users.data" :key="v && v.id" :class="{ 'deleted': v.is_locked }">
                <div class="card-body">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-start">
                            <button class="btn btn-outline-primary btn-xs me-3" @click="edit(v.id)">
                                <TablerIcon name="IconEdit" :size="18" />
                                編集
                            </button>
                            <div>
                                <div class="d-flex justify-content-start">
                                    <h3 class="card-title me-3 mb-0">
                                        {{ v.name }}
                                    </h3>
                                    <div class="small">
                                        <div v-if="v.account">
                                            {{ v.account }}
                                        </div>
                                        <div class="catd-text">
                                            {{ v.email }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button class="btn btn-outline-danger btn-xs" @click="toggle(v)" v-if="!v.is_locked">
                                <TablerIcon name="IconLock" :size="18" />
                                ロック
                            </button>
                            <button class="btn btn-outline-success btn-xs" @click="toggle(v)" v-else>
                                <TablerIcon name="IconLockOpen2" :size="18" />
                                ロック解除
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ユーザマスタモーダル -->
            <users-editor
                :user_id="user_id"
                ref="UsersEditor"
                @mounted="modalMounted($event)"
                @close="closeModal($event)"
                @save="reload()"></users-editor>

        </div>
    </div>
</template>

<script>
import usersEditor from './usersEditor.vue';
import simpleSearch from 'components/simpleSearch.vue';

export default {
    components: {
        usersEditor,
        simpleSearch,
    },
    data() {
        return {
            show: true,
            user_id: null,
            users: [],
            modals: {},
            page: this.$route.query.page || 1,
            keyword: this.$route.query.keywords || "",
        };
    },
    methods: {
        clear() {
            this.keyword = '';
            this.goto(1);
        },
        find() {
            this.goto(1);
        },
        goto(page) {
            this.page = page;
            setTimeout(() => {
                this.reload();
            });
        },
        reload() {
            this.isLoading = true;
            const params = {
                page: this.page,
                keyword: this.keyword,
            };
            this.$router.push({ query: params }).catch(() => {});
            axios.get('/master/users/lists', {params: params}).then((res) => {
                this.users = res.data;
                this.isLoading = false;
            }).catch((err) => {
                Alert.err(err.response);
                this.isLoading = false;
            });
        },
        append() {
            this.edit(null);
        },
        edit(id) {
            this.user_id = id;
            setTimeout(() => {
                const modal_instance = this.modals['users-editor'];
                if (!modal_instance) return;
                modal_instance.show();
            });
        },
        sync() {
            swal({
                title: 'AD同期',
                text: 'ユーザ一覧をActive Directoryに同期します。\nよろしいですか？',
                icon: 'info',
                buttons: ['キャンセル', '同期'],
            }).then((will_sync) => {
                if (!will_sync) return;

                axios.post('/master/users/sync').then((res) => {
                    this.reload();
                    setTimeout(() => Alert.msg(res.data));
                }).catch((err) => {
                    Alert.err(err.response);
                });
            });
        },
        toggle(v) {
            let action = '解除';
            let type = 'info';
            let mode = false;
            if (!v.is_locked) {
                action = 'ロック';
                type = 'error';
                mode = true;
            }
            swal({
                title: `ユーザマスタ${action}`,
                text: `指定のユーザを${action}します。\nよろしいですか？`,
                icon: type,
                buttons: ['キャンセル', action],
                dangerMode: mode,
            }).then((willDelete) => {
                if (willDelete) {
                    axios.post('/master/users/toggle', { id: v.id }).then((res) => {
                        this.reload();
                        setTimeout(() => Alert.msg(res.data));
                    }).catch((err) => {
                        Alert.err(err.response);
                    });
                }
            });
        },
        modalMounted(id) {
            this.modals[id] = new bootstrap.Modal(document.getElementById(id));
        },
        closeModal() {
            this.reload();
        },
    },
    mounted() {
        this.reload();
    },
};
</script>
